import { LitElement, html, TemplateResult } from 'lit';
import {customElement} from 'lit/decorators.js';

@customElement('berner-redirect')
export class BernerRedirect extends LitElement {

    firstUpdated(): void {
        window.location.replace("http://34.239.207.210:3000");
    }

    render(): TemplateResult {
        return html`
            <head content="width=device-width, initial-scale=1">
            </head>`;
    }
}
